const getDaysLeft = (fundingEndDate) => {
  if (!fundingEndDate) return 0;

  const endDate = Number(fundingEndDate) * 1000;

  const now = Date.now();

  const diff = endDate - now;

  if (diff <= 0) return 0;

  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

const ENDED_PROJECT_STATUSES = new Set([
  'finished',
  'successful',
  'closed',
  'ended',
]);

const isProjectEnded = (project) => {
  const status = String(project?.status || '').toLowerCase();

  if (ENDED_PROJECT_STATUSES.has(status)) return true;
  if (!project?.funding_end_date) return false;

  return Number(project.funding_end_date) * 1000 <= Date.now();
};

export const getTicketProgressInfo = ({ project, tickets = [] }) => {
  const hideTicketSalesCount = !!project?.hide_ticket_sales_count;
  const projectEnded = isProjectEnded(project);
  const hasUnlimitedTickets = tickets.some(
    (ticket) => Number(ticket.max_order_count || 0) <= 0
  );

  const totalTarget = tickets.reduce((acc, ticket) => {
    const max = Number(ticket.max_order_count || 0);

    // Unlimited tickets do not contribute to a finite contingent.
    if (max <= 0) return acc;

    return acc + max;
  }, 0);

  const totalSold = tickets.reduce((acc, ticket) => {
    const max = Number(ticket.max_order_count || 0);

    if (max <= 0) return acc;

    return acc + Number(ticket.ordered_reward_count || ticket.order_count || 0);
  }, 0);

  const totalRemaining = Math.max(totalTarget - totalSold, 0);
  const hasContingent = totalTarget > 0;

  const percentage = projectEnded || !hasContingent
    ? 100
    : totalTarget > 0
      ? Math.min(Math.round((totalSold / totalTarget) * 100), 100)
      : 0;

  if (projectEnded) {
    return {
      type: 'ended',
      label: 'Ticketverkauf beendet',
      totalTarget,
      totalSold,
      totalRemaining,
      percentage,
      hasContingent,
      hasUnlimitedTickets,
      showContingent: false,
      isEnded: true,
    };
  }

  if (hideTicketSalesCount) {
    const daysLeft = getDaysLeft(project?.funding_end_date);

    return {
      type: 'days',
      label:
        daysLeft <= 0
          ? 'Beendet'
          : `Noch ${daysLeft} Tag${daysLeft === 1 ? '' : 'e'}`,
      totalTarget,
      totalSold,
      totalRemaining,
      percentage,
      hasContingent,
      hasUnlimitedTickets,
      showContingent: false,
      isEnded: false,
    };
  }

  return {
    type: 'tickets',
    label:
      totalTarget <= 0
        ? 'Unbegrenzt verfügbar'
        : hasUnlimitedTickets && totalRemaining <= 0
        ? 'Limitierte Tickets ausverkauft – weitere Tickets unbegrenzt verfügbar'
        : hasUnlimitedTickets
        ? `Noch ${totalRemaining} von ${totalTarget} limitierten Tickets`
        : totalRemaining <= 0
        ? 'Ausverkauft'
        : `Noch ${totalRemaining} Ticket${
            totalRemaining === 1 ? '' : 's'
          }`,
    totalTarget,
    totalSold,
    totalRemaining,
    percentage,
    hasContingent,
    hasUnlimitedTickets,
    showContingent: hasContingent,
    isEnded: false,
  };
};
